import React from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import CardCta from "@app/component/DashCard/CardCta";
import ManageFunnelsModal from "@app/scene/deal/component/ManageFunnelsModal";
import authService from "@app/store/auth/AuthService";
import { isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./EmptyRecordsStats.module.scss";

const messages = defineMessages({
  assignRotLimit: {
    id: "home.cards.dealsRotting.emptyRecordsStats.assignRotLimit",
    defaultMessage: "Assign rot limits to deal stages to never lose track of a deal",
    description: "",
  },
  learnMore: {
    id: "home.cards.dealsRotting.emptyRecordsStats.learnMore",
    defaultMessage: "Learn more about deals",
    description: "",
  },
  manageFunnels: {
    id: "home.cards.dealsRotting.emptyRecordsStats.manageFunnels",
    defaultMessage: "Manage funnels & stages",
    description: "",
  },
  noDeals: {
    id: "home.cards.dealsRotting.emptyRecordsStats.noDeals",
    defaultMessage: "No rotting deals",
    description: "",
  },
});

const CADENCE_ARTICLE_URL =
  "https://support.mapmycustomers.com/hc/en-us/articles/360047679953-Deal-Stages";

interface Props {
  isOwner: boolean;
}

const EmptyRecordsStats: React.FC<Props> = ({ isOwner }) => {
  const intl = useIntl();

  const [isFunnelSettingsModalOpen, showFunnelSettings, hideFunnelSettings] = useBoolean();
  const token = authService.getToken();

  if (!token) {
    return null;
  }

  return (
    <>
      <CardCta
        buttonLabel={intl.formatMessage(messages.manageFunnels)}
        buttonVisible={isOwner ? true : false}
        onClick={showFunnelSettings}
        text={
          <>
            <p>{intl.formatMessage(messages.noDeals)}</p>
            {isOwner && (
              <p className={styles.instructions}>{intl.formatMessage(messages.assignRotLimit)}</p>
            )}
          </>
        }
      >
        <a href={CADENCE_ARTICLE_URL} rel="noopener noreferrer" target="_blank">
          {intl.formatMessage(messages.learnMore)}
        </a>
      </CardCta>
      {isFunnelSettingsModalOpen && <ManageFunnelsModal onHide={hideFunnelSettings} />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isOwner: isCurrentUserOwner(state),
});

export default connect(mapStateToProps)(EmptyRecordsStats);
